import DeclarantStore from "./DeclarantStore";
import ee from "../services/EventEmitter";
import { DELETE_SIGMA_EVENT } from "../constants/events";

class SigmaStore extends DeclarantStore {
  init() {
    ee.on(DELETE_SIGMA_EVENT, (id) => {
      this.deleteEntity(id);
    });
  }

  protected getDeclarants(): Promise<Response> {
    return this.apiManager.getSigma(this._parameters);
  }
}

export default SigmaStore;
